import React, { createContext, useState, useEffect, useContext } from 'react';
import {
  getPricePlans,
  signupAPI,
  generateOtpAPI,
  verifyOtpAPI,
  promoCodeAPI,
  subscriptionTransactionAPI,
  // addDeliverAddressAPI,
  cardUpdateAPI,
} from './api-services/subscriptionSignup.service';

import { addDeliveryAddressAPI } from './api-services/deliveryAddress.service';

import {
  API_NETWORK_ERROR,
  CARD_DECLINED_ERROR,
  CARD_INAVLID_ERROR,
  localStorageKeys,
} from '../global/constants';
import axios from 'axios';
import { StoreHeaderDataContext } from './StoreHeaderDataProvider';
import { LoginDataContext } from './LoginDataProvider';

export const SignUpInfoDataContext = createContext();

const personOptionsMap = {
  'One person': '1',
  'Two person': '2',
  'Three person': '3',
  'Four person': '4',
};

const SignUpInfoDataProvider = ({ children }) => {
  const { kitchensByZipcode } = useContext(StoreHeaderDataContext) || {};
  const { isLoggedIn, onCustomerInformationApiHandler, customerInfoData, onLogout, fingerPrint } =
    useContext(LoginDataContext);
  const { REFRESH_TOKEN, TOKEN, MANAGING_BRANCH_NAME, URL_INFLUE_CODE } = localStorageKeys;

  // Card Input
  const [cardNumber, setCardNumber] = useState(null);
  const [expiryMonth, setExpiryMonth] = useState(null);
  const [expiryYear, setExpiryYear] = useState(null);
  const [cvcValue, setCvcValue] = useState(null);

  //stepper context
  const [openOtpVerify, toggleOtpVerify] = useState(false);
  const [completed, setCompleted] = useState([]);
  const [accountType, setAccountType] = useState('');
  const [authentication, setAuthentication] = useState('');
  const [promoCode, setPromoCode] = useState('');
  const [promoCodeSubcriptionRespo, setPromoCodeSubcriptionRespo] = useState({
    errors: null,
    isLoading: false,
    data: null,
    success: null,
    message: null,
  });

  const [isPromoApplied, setIsPromoApplied] = useState(false);
  const [fullName, setFullName] = useState('');
  const [isCardError, setCardError] = useState(false);
  const [signupAPIResponse, setSignupAPIResponse] = useState({
    errors: null,
    isLoading: false,
    response: null,
    data: null,
    success: null,
    message: null,
  });
  const [generateOtpAPIResponse, setGenerateOtpAPIResponse] = useState({
    isLoading: false,
    data: null,
    success: null,
    message: null,
  });

  const [verifyOtpAPIResponse, setVerifyOtpAPIResponse] = useState({
    isLoading: false,
    data: null,
    success: null,
    message: null,
  });

  const [subscriptionTransResponse, setSubscriptionTransResponse] = useState({
    isLoading: false,
    data: null,
    message: null,
    success: null,
    errors: null,
  });

  const [email, setEmail] = useState('');
  const [cardDeclined, setCardDeclined] = useState(false);
  const [signUpformValues, setSignUpformValues] = useState({});
  const localStorageManagingBranch = () => localStorage.getItem(MANAGING_BRANCH_NAME);

  //stepper context
  const [pricingPlans, setPricingPlans] = useState({
    personOptionsMap,
    mealOptions: [],
    personOptions: [],
    isLoading: false,
    data: null,
    error: null,
  });

  const clearSignUpData = () => {
    toggleOtpVerify(false);
    setAccountType('');
  };

  const getPricePlansDataAPI = async (params) => {
    setPricingPlans({ ...pricingPlans, error: null, isLoading: true });
    try {
      const pricingResponse = await getPricePlans({
        device: 'desktop',
        managing_branch_name: localStorageManagingBranch(),
      });

      const rawMealPlans = {};
      const mealsPlans = await {};
      await pricingResponse.data.data.forEach((plan) => {
        if (!mealsPlans[plan.meal_plan]) {
          mealsPlans[plan.meal_plan] = {};
        }
        mealsPlans[plan.meal_plan][plan.plan_plates] = plan;
        rawMealPlans[plan.meal_plan_id] = plan;
      });

      const personOptions = [];
      const mealOptions = [];
      const mealPlanIds = [];

      // Generate options & array of plan ids for Toggle Buttons in each plan to avoid this logic in component level
      await Object.keys(mealsPlans).forEach((plan) => {
        // console.log("plan", mealsPlans, plan);
        personOptions.push({
          label: personOptionsMap[plan],
          value: plan,
        });
        mealsPlans[plan].options = [];
        mealsPlans[plan].meal_plan_ids = [];
        Object.keys(mealsPlans[plan]).forEach((el) => {
          const id = mealsPlans[plan][el].meal_plan_id;
          if (el !== 'options' && el !== 'meal_plan_ids') {
            mealOptions.push({
              label: `${el}`,
              value: `${el}`,
              id,
            });
            mealsPlans[plan].options.push({
              label: `${el}`,
              value: `${el}`,
              id,
            });
          }
          if (id) {
            mealsPlans[plan].meal_plan_ids.push(id);
            mealPlanIds.push(id);
          }
        });
      });
      await setPricingPlans({
        personOptionsMap,
        personOptions,
        mealOptions,
        mealPlanIds: [...new Set(mealPlanIds)],
        data: mealsPlans,
        rawMealPlans,
        error: null,
        isLoading: false,
      });
    } catch (error) {
      console.log('getPricePlansData error', error);
      setPricingPlans({
        personOptionsMap,
        mealPlanIds: [],
        personOptions: [],
        mealOptions: [],
        data: null,
        error,
        isLoading: false,
      });
    }
  };

  // state for sign up Page email, to get email in next steps (OTP TOKEN COMPONENT)
  const [signUpPageEmail, setSignUpPageEmail] = useState('');
  const getInflueLocalStorage = () => localStorage.getItem(URL_INFLUE_CODE);

  const signUpAPIHandler = async (payload) => {
    try {
      const {
        firstName,
        lastName,
        email,
        password,
        confirmPassword,
        authentication,
        auth_token,
        card_number,
        exp_month,
        exp_year,
        cvc,
        phone_no = 'none', // we have to add input box for phone_no on sigup page
      } = payload;

      const data = {
        firstName,
        lastName,
        email,
        password,
        retype_password: confirmPassword,
        account_type: accountType,
        zipcode: kitchensByZipcode?.zipcode,
        authentication: authentication,
        auth_token: auth_token,
        finger_print: fingerPrint,

        influencer_promoter_id: getInflueLocalStorage() || 'none',
      };

      await setSignupAPIResponse({
        errors: null,
        isLoading: true,
        response: null,
        data: null,
        success: null,
        message: null,
      });

      const response = await signupAPI(data);

      if (response.hasError) {
        setSignupAPIResponse({
          errors: response?.message?.errors || null,
          isLoading: false,
          data: response?.message,
          success: false,
          message: null,
        });
        return response;
      }

      if (response?.data && response?.data.success) {
        setSignupAPIResponse({
          errors: null,
          isLoading: false,
          data: response?.data,
          success: response?.data?.success,
          message: response?.data?.CustomMessage,
        });

        // OTP Email Verify
        if (response.data.token) {
          axios.defaults.headers.common.Authorization = `Bearer ${response.data.token}`;
          localStorage.setItem(REFRESH_TOKEN, response?.data?.refresh_token);
          localStorage.setItem(TOKEN, response?.data?.token);
          const custResponse = await onCustomerInformationApiHandler();
          setFullName(firstName + ' ' + lastName);
          setSignUpPageEmail(email);
        }

        if (authentication === 'email') {
          toggleOtpVerify(true);
          generateOtpAPIHandler(email);
        }

        return response?.data;
      }

      if (response?.data && response?.data?.success === false) {
        setSignupAPIResponse({
          errors: response.data.errors,
          isLoading: false,
          data: response?.data,
          success: response?.data.success,
          message: '',
        });
        return response?.data;
      }

      // This is for catch block error coming from backend
      if (response && response?.errors?.success === false) {
        setSignupAPIResponse({
          errors: response?.errors,
          isLoading: false,
          data: response?.data,
          success: response?.errors?.success === false,
          message: `${response?.errors?.CustomMessage} #REF-66909`,
        });
        return response;
      }
    } catch (errors) {
      setSignupAPIResponse({
        errors: errors,
        isLoading: false,
        data: null,
        success: false,
        message: `Catch block #REF-889910`,
      });
    }
  };

  const generateOtpAPIHandler = async (email) => {
    setGenerateOtpAPIResponse({
      isLoading: true,
      data: null,
      success: null,
      message: null,
    });
    try {
      const response = await generateOtpAPI(email);
      // Remove this console.log comment before going production
      // console.log('generate otp response', response);
      if (response.hasError) {
        await setSignupAPIResponse({
          isLoading: false,
          errors: [{ ErrorMessage: response.message, param: API_NETWORK_ERROR }],
        });

        await setGenerateOtpAPIResponse({
          loading: false,
          data: null,
          success: !response.hasError,
          message: response.message,
        });
        return;
      }
      if (response.data?.success) {
        await setSignupAPIResponse({
          isLoading: false,
          errors: null,
        });
        await setGenerateOtpAPIResponse({
          isLoading: false,
          data: null,
          success: response.data?.success,
          message: response.data?.CustomMessage,
        });
      }

      if (response.data?.success === false) {
        await setGenerateOtpAPIResponse({
          isLoading: false,
          data: null,
          success: response.data?.success,
          message: response.data?.CustomMessage || response.data?.errors[0].ErrorMessage,
        });
      }
    } catch (error) {
      await setSignupAPIResponse({
        isLoading: false,
        errors: [{ ErrorMessage: error.message, param: 'Network Error' }],
      });
      await setGenerateOtpAPIResponse({
        isLoading: false,
        data: null,
        success: false,
        message: error,
      });
      console.log('-----Catch block generateOtpAPIHandler', error);
    }
  };

  const verifyEmailOTPAPIHandler = async (email, otpNo) => {
    await setVerifyOtpAPIResponse({
      isLoading: true,
      data: null,
      success: null,
      message: null,
    });

    try {
      const response = await verifyOtpAPI({ email, otpNo });
      // Remove this console.log comment before going production
      console.log('verify otp response', response);
      if (response.hasError) {
        await setSignupAPIResponse({
          isLoading: false,
          errors: [{ ErrorMessage: response.message, param: API_NETWORK_ERROR }],
        });
        setEmail('');
        await setVerifyOtpAPIResponse({
          loading: false,
          data: null,
          success: !response.hasError,
          message: response.message,
        });

        return response;
      }
      if (response.data?.success === false) {
        await setSignupAPIResponse({
          isLoading: false,
          errors: response.data.errors || [{ ErrorMessage: response.data.CustomMessage }],
        });
        setEmail('');
        await setVerifyOtpAPIResponse({
          isLoading: false,
          data: null,
          success: response.data?.success,
          message: response.data?.CustomMessage || response.data?.errors[0].ErrorMessage,
        });
        return response;
      } else {
        await setSignupAPIResponse({
          isLoading: false,
          errors: null,
        });
        setEmail(email);
        await setVerifyOtpAPIResponse({
          isLoading: false,
          data: null,
          success: response.data?.success,
          message: response.data?.CustomMessage,
        });

        return response;
      }
    } catch (error) {
      await setSignupAPIResponse({
        isLoading: false,
        errors: [{ ErrorMessage: error.message, param: 'Network Error' }],
      });
      setEmail('');
      await setVerifyOtpAPIResponse({
        isLoading: false,
        data: null,
        success: false,
        message: error,
      });
      console.log('-----Catch block verifyEmailOTPAPIHandler', error);
    }
  };

  const promoCodeAPIHandler = async (payload) => {
    try {
      setPromoCodeSubcriptionRespo({
        errors: null,
        isLoading: true,
        data: null,
        success: false,
        message: null,
      });

      const response = await promoCodeAPI({
        discount_code: payload.discount_code,
        meal_plan_id: payload.meal_plan_id,
        zipcode: payload.zipcode,
        email: payload.email || null,
      });

      if (response.hasError) {
        setPromoCodeSubcriptionRespo({
          errors: null,
          isLoading: false,
          data: response?.data,
          success: false,
          message: response?.message,
        });
        return response.data;
      }

      if (response?.data?.success) {
        setPromoCodeSubcriptionRespo({
          errors: null,
          isLoading: false,
          data: response?.data,
          success: response?.data?.success,
          message: response?.data?.message,
        });

        setIsPromoApplied(true);
      }

      if (response?.data?.success === false) {
        setPromoCodeSubcriptionRespo({
          errors: null,
          isLoading: false,
          data: response?.data,
          success: response?.data?.success,
          message: response?.data?.message,
        });

        setIsPromoApplied(false);
      }

      return response?.data;
    } catch (error) {
      setPromoCodeSubcriptionRespo({
        errors: error,
        isLoading: false,
        data: null,
        success: false,
        message: `Catch block #REF-886765`,
      });
    }
  };

  const subscriptionTransactionAPIHandler = async (payload) => {
    try {
      setSubscriptionTransResponse({
        errors: null,
        isLoading: true,
        data: null,
        success: false,
        message: null,
      });

      const gettingToken = localStorage.getItem(TOKEN);

      if (gettingToken) {
        axios.defaults.headers.common.Authorization = `Bearer ${gettingToken}`;
      } else {
        setSubscriptionTransResponse({
          isLoading: false,
          data: null,
          success: false,
          message: 'Token & Refresh Token missing',
        });
        return;
      }

      const response = await subscriptionTransactionAPI(payload);

      if (response.hasError) {
        setSubscriptionTransResponse({
          errors: null,
          isLoading: false,
          data: response?.data,
          success: false,
          message: response?.message,
        });
        return response.data;
      }

      if (response?.data?.success) {
        setSubscriptionTransResponse({
          errors: null,
          isLoading: false,
          data: response?.data,
          success: response?.data?.success,
          message: response?.data?.customMessage,
        });

        return response?.data;
      }

      if (response?.data?.success === false) {
        setSubscriptionTransResponse({
          errors: response?.data?.errors,
          isLoading: false,
          data: response?.data,
          success: response?.data?.success,
          message: response?.data?.customMessage,
        });

        return response?.data;
      }
    } catch (error) {
      setSubscriptionTransResponse({
        errors: error,
        isLoading: false,
        data: null,
        success: false,
        message: `Catch block #REF-7799678`,
      });
    }
  };

  const addDeliveryAddressAPIHandler = async (payload) => {
    try {
      await setSignupAPIResponse({
        ...signupAPIResponse,
        isLoading: true,
        errors: null,
      });
      const response = await addDeliveryAddressAPI(payload);
      if (response.data.success) {
        setOrderSummary({});
        await setSignupAPIResponse({
          ...signupAPIResponse,
          isLoading: false,
          errors: null,
        });
      } else {
        await setSignupAPIResponse({
          ...signupAPIResponse,
          isLoading: false,
          errors: response.data.errors,
        });
      }
    } catch (error) {
      await setSignupAPIResponse({
        isLoading: false,
        errors: [{ ErrorMessage: 'Network Error', param: 'Network Error' }],
      });
    }
  };

  // const [loading, setLoader] = useState(false);
  const [stripeError, setStripeError] = useState(null);
  const [token, setToken] = useState(null);
  const [formError, setFormError] = useState(null);
  const [selectedMealPlan, setMealPlanId] = useState('');
  const [orderSummary, setOrderSummaryState] = useState({});
  const [orderSummaryWithoutPromo, setOrderSummaryWithoutPromo] = useState({});
  const [taxPercentageSubscription, setTaxPercentageSubscription] = useState(10.25);
  const [promoAppliedOrderSummary, setPromoAppliedOrderSummary] = useState({});

  const setOrderSummary = async (data) => {
    // await console.log('setOrderSummary', data)
    setOrderSummaryState({ ...data });
  };

  const setMealPlan = (mealPlanId) => {
    try {
      setMealPlanId(mealPlanId);
      const { rawMealPlans } = pricingPlans;
      const {
        meal_plan,
        plan_plates,
        plan_price = 0,
        total_delivery_service_fees = 0,
        delivery_service_fees = 0,
        managing_branch_name,
      } = rawMealPlans[mealPlanId] || {};

      const personsDataMap = {
        'One person': 1,
        'Two person': 2,
        'Four person': 4,
      };

      const taxPercent = taxPercentageSubscription; // We have to calulate tax dynamicaly based on zipcode and This calculation should be on API /SubscriptionTransaction as well
      const calculatedTaxAmt = +(plan_price * (taxPercent / 100)).toFixed(2);
      const calcuatedTotal = +(plan_price + calculatedTaxAmt).toFixed(2);

      const orderSummaryData = {
        ...orderSummary,
        rawMealPlans: rawMealPlans[mealPlanId] || {},
        noOfPersons: personsDataMap[meal_plan],
        mealPlan: `${meal_plan} ${plan_plates} meals`,
        freeMealPlates: 'Not Applied',
        promoStatus: 'Not Applied',
        promoType: 'Can be added on next page',
        totalDeliveryServiceFees: total_delivery_service_fees,
        subTotal: plan_price,
        totalMeals: plan_plates,
        taxAmount: calculatedTaxAmt, // Tax(59.99 @ 5%) 2.25
        total: calcuatedTotal,
        total_deliveries: plan_plates,
        taxPercentage: `${taxPercent}%`,
        mealPlanId: mealPlanId,
      };
      // setOrderSummaryWithoutPromo(orderSummaryData)
      setOrderSummary(orderSummaryData);
    } catch (error) {
      console.error('Error at SetMealPlan', error);
    }
  };

  useEffect(() => {
    if (localStorage.email && localStorage.isEmailVerified === 'false') {
      toggleOtpVerify(true);
    }
  }, []);

  return (
    <SignUpInfoDataContext.Provider
      value={{
        stripeError,
        setStripeError,
        token,
        setToken,
        formError,
        setFormError,
        selectedMealPlan,
        setMealPlan,
        pricingPlans,
        getPricePlansDataAPI,
        accountType,
        setAccountType,
        authentication,
        setAuthentication,
        signUpformValues,
        setSignUpformValues,
        completed,
        setCompleted,
        openOtpVerify,
        toggleOtpVerify,
        signUpAPIHandler,
        signupAPIResponse,
        setSignupAPIResponse,
        generateOtpAPIHandler,
        verifyEmailOTPAPIHandler,

        promoCodeSubcriptionRespo,
        setPromoCodeSubcriptionRespo,
        promoCodeAPIHandler,
        taxPercentageSubscription,
        promoAppliedOrderSummary,
        setPromoAppliedOrderSummary,
        subscriptionTransactionAPIHandler,
        subscriptionTransResponse,
        setSubscriptionTransResponse,
        addDeliveryAddressAPIHandler,
        setPromoCode,
        promoCode,
        isPromoApplied,
        setIsPromoApplied,
        orderSummary,
        setOrderSummary,
        orderSummaryWithoutPromo,
        setOrderSummaryWithoutPromo,
        email,
        signUpPageEmail,
        setSignUpPageEmail,
        cardDeclined,
        fullName,
        clearSignUpData,
        setMealPlanId,
        setGenerateOtpAPIResponse,
        generateOtpAPIResponse,
        verifyOtpAPIResponse,
        setVerifyOtpAPIResponse,
        isCardError,
        setCardError,

        cardNumber,
        setCardNumber,
        expiryMonth,
        setExpiryMonth,
        expiryYear,
        setExpiryYear,
        cvcValue,
        setCvcValue,
      }}
    >
      {children}
    </SignUpInfoDataContext.Provider>
  );
};

export default SignUpInfoDataProvider;
